import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'Art of Thinking';

// Exact-path titles for the public surface. Dynamic/app routes keep the base
// title (their content is user-specific and mostly behind share codes or auth).
const TITLES: Record<string, string> = {
    '/science': 'Science',
    '/about': 'About',
    '/whitepaper': 'White Paper',
    '/protocol': 'Analysis Protocol',
    '/data-ownership': 'Data Ownership',
    '/privacy-policy': 'Privacy Policy',
    '/terms-of-service': 'Terms of Service',
    '/research': 'Research',
    '/research/adhd': '40 Words · ADHD Research',
    '/research-info': 'Research Information',
    '/research-participation': 'Research Participation',
    '/research-terms': 'Research Terms',
    '/public': 'Self-Research Studies',
    '/public-research': 'Research Archive',
    '/start': 'Available exercises',
    '/shared-language': 'Build your shared language',
    '/signin': 'Sign In',
    '/host/home': 'Your work',
    '/host/sessions': 'All sessions',
};

const RouteTitle = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
        const page = TITLES[normalized];
        document.title = page ? `${page} · ${BASE_TITLE}` : BASE_TITLE;
    }, [pathname]);

    return null;
};

export default RouteTitle;
